module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"errorCode":"Error code"}}')
  delete Component.options._Ctor
}
